import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { CommonService } from 'src/app-core/services/common.service';

@Injectable({
  providedIn: 'root',
})

export class PackagingService {

  constructor(
    private apiCommonService: ApiCommonService,
    private commonService: CommonService) {
  }

  getGridRecords(event: any, searchQuery: string, filterQuery: string): Observable<any> {
    return this.apiCommonService.getGridRecords('Packaging', event, searchQuery, '', filterQuery);
  }

  createPackaging(data: any): Observable<any> {
    return this.apiCommonService.post('Packaging', data);
  }

  getPackaging(id: any, query?: any): Observable<any> {
    return this.apiCommonService.get(`Packaging/Id?Id=${id}${query}`);
  }

  updatePackaging(data: any): Observable<any> {
    return this.apiCommonService.post('Packaging/Update', data);
  }

  getPackagingLookup(searchKey: string): Observable<any> {
    return this.apiCommonService.get(`Packaging/Lookup?SearchQuery=${searchKey}`);
  }

  packagingStatusUpdate(data: object): Observable<object> {
    return this.apiCommonService.put('Packaging/Delete', data);
  }
}
